import * as React from "react";
import { NavigationStep, Page } from "../../types";
import { Patient, PatientFormParams } from "../../patient/types";
import Select from "react-select";
import DatePicker from "react-datepicker";
import PatientAddEdit from "../../patient/components/PatientAddEdit";
import { FormikErrors } from "formik";

interface StoreProps {
  patientList: Page<Patient>;
}

interface DispatchProps {
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
}

interface OwnProps {
  locations: string[];
  action: (
    params: PatientFormParams,
    onError: (error: FormikErrors<PatientFormParams>) => void,
    id?: string
  ) => void;
}

interface OwnState {
  showMenu: boolean;
  appointmentDate: Date;
  appointmentTime: Date | null;
  addNewPatient: boolean;
}

type Props = StoreProps & DispatchProps & OwnProps;

class AddAppointment extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected dropdownMenu: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      showMenu: false,
      appointmentDate: new Date(),
      appointmentTime: null,
      addNewPatient: false
    };

    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public showMenu(event: any) {
    event.preventDefault();
    if (this.state.showMenu) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener("click", this.closeMenu);
      });
    } else {
      this.setState({ showMenu: true, addNewPatient: false }, () => {
        document.addEventListener("click", this.closeMenu);
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public closeMenu(event?: any) {
    if ((event && !this.dropdownMenu.contains(event.target)) || !event) {
    }
  }

  private appointmentTypes = () => {
    return [
      { value: "Office Appointment", label: "Office Appointment" },
      { value: "Remote Video", label: "Remote Video" }
    ];
  };

  private patientDropdown = () => {
    return this.props.patientList.results.map(p => {
      return { value: p.id, label: p.familyName + ", " + p.givenName };
    });
  };

  private setStartDate = (date: Date) => {
    this.setState({ appointmentDate: date });
  };

  private setStartTime = (date: Date) => {
    this.setState({ appointmentTime: date });
  };

  private addNewPatientChanged = () => {
    this.setState({ addNewPatient: true });
  };

  render() {
    return (
      <div className="actionContainer">
        <button onClick={this.showMenu}>
          <i className="far fa-plus-circle btn-icon" /> Add Patient Appointment
        </button>

        {this.state.showMenu && (
          <div
            className="dialog-menu"
            ref={element => {
              this.dropdownMenu = element;
            }}
          >
            <div className="dialog-content">
              {!this.state.addNewPatient ? (
                <div>
                  <label htmlFor="existing-patient">Select Existing Patient</label>
                  <div className="flex-between-center">
                    <Select
                      id="existing-patient"
                      className="full-width mr-15"
                      // eslint-disable-next-line no-console
                      onChange={e => console.log(e)}
                      options={this.patientDropdown()}
                    />

                    <button onClick={() => this.addNewPatientChanged()}>Add New Patient</button>
                  </div>
                </div>
              ) : (
                <PatientAddEdit
                  actionText="Add Patient"
                  action={this.props.action}
                  locations={this.props.locations}
                />
              )}

              <label htmlFor="apt-type">Appointment Type</label>
              <Select
                id="apt-type"
                options={this.appointmentTypes()}
                defaultValue={this.appointmentTypes()[0]}
              />
              <label htmlFor="apt-date">Appointment Date</label>
              <div className="flex-center">
                <DatePicker
                  id="apt-date"
                  selected={this.state.appointmentDate}
                  onChange={(date: Date) => this.setStartDate(date)}
                />
                <DatePicker
                  id="apt-time"
                  selected={this.state.appointmentTime}
                  onChange={(date: Date) => this.setStartTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                />
              </div>
              <div className="flex-end mt-15">
                <button>Add Appointment</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AddAppointment;
